import { Component, OnInit, Input } from "@angular/core";
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment as params } from "src/environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { HomeService } from "src/app/core/http/web/home.service";
import { ContactoService } from '../../../../motores/vuelos/services/contacto.service';
import MD5 from 'md5';
declare let ga: Function;
@Component({
  selector: "app-tks-seguros",
  templateUrl: "./tks-seguros.component.html",
  styleUrls: ["./tks-seguros.component.scss"]
})
export class TksSegurosComponent implements OnInit {
  public sessionname: String = '';
  public loadServ: Boolean = true;
  public generalData: any;
  public _fDestino: any = false;
  public dataTable: any = false;
  public client: any = null;
  public paymentStatus: boolean;
  public totalSum: any = 0;
  public url: String = '';
  public newAck = 'hxeSYK8ZmuRZhQYZ';
  public newKey: any;
  public tokenIntegrator: any;
  public addOnSelected: any;
  public insuranceSelected;
  public _moment: any;
  public numberOfUsers: any = [];
  public addPrice: any = 0;
  public product: any;
  public detailsUsersAndOnds: any = [];
  public year: any;


  public arreglopromo :any;
  public arrayvacio;

  urlBaseS3: any = (<any>params).api.s3;
  urlBaseMJ: any = (<any>params).api.mj;

  submitted = false;
  public loader = false;
  public sendDataResponse = false;
  public sendDataMessage = '';
  public sendDataMessageTwo = '';
  public sendDataImage = '';

  public llamameForm = this.formBuilder.group({
    nombre: ['', [Validators.required, Validators.pattern(/^([a-zA-ZùÙüÜäàáëèéïìíöòóüùúÄÀÁËÈÉÏÌÍÖÒÓÜÚñÑ\s]+)$/)]],
    apellido: ['', [Validators.required, Validators.pattern(/^([a-zA-ZùÙüÜäàáëèéïìíöòóüùúÄÀÁËÈÉÏÌÍÖÒÓÜÚñÑ\s]+)$/)]],
    celular: ['', [Validators.required, Validators.minLength(10), Validators.pattern(/^[0-9]*$/)]]
  });

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private _homeService: HomeService,
    private contactoService: ContactoService,
  ) {
      console.log('send view page thkpage', this.router.url);
      if (typeof(ga) !== 'undefined') {
        ga('send', 'pageview', this.router.url);
        ga('send', {
          hitType: 'pageview',
          page: this.router.url
        });
      }
    moment.locale("es");
    this._moment = moment;

    this.contactoService.getToken().subscribe((res: any) => {
      this.tokenIntegrator = res.token;
      this.newKey = MD5(res.token + this.newAck);
      this.getSessionname(this.newKey);
    });
    this.route.queryParams.subscribe(params => {
      if (JSON.stringify(params) !== "{}") {
        if (params.status && params.name && params.lastname && params.email) {
          this.paymentStatus = JSON.parse(params.status).paymenStatus;
          const cliente = {
            clave: params.key,
            status:
              isJson(params.status) && JSON.parse(params.status).message != null
                ? JSON.parse(params.status).message
                : "ERROR",
            name: params.name,
            lastname: params.lastname,
            email: params.email,
            tel: params.tel,
            totalPayment: params.totalPayment
          };
          this.client = cliente;
        } else {
          console.warn("Parametros incorrectos");
          this.router.navigate(["/m/seguros/ups-error"]);
        }
      } else {
        console.warn("No hay parametros");
        this.router.navigate(["/m/seguros/ups-error"]);
      }
    });
  }

  ngOnInit() {
    if (this.loadServ) {
      this.getGeneralOptions();
    }

    this.url = sessionStorage.getItem('url').replace('/m/seguros/resultados/destino?', '');
    const param_pair_string = this.url.split('&');
    const fDestino = param_pair_string.filter(rep =>  rep.includes('fDestino') );
    this._fDestino = fDestino[0].split('=')[1];
    //this._fDestino = 'México';

    this.product = JSON.parse(sessionStorage.getItem("product"));
    this.dataTable = JSON.parse(localStorage.getItem("planes"));
    this.addOnSelected = sessionStorage.getItem("addOns")
      ? JSON.parse(sessionStorage.getItem("addOns"))
      : null;

    window.dataLayer.push({
      'transactionAffiliation': this.client.clave,
      'transactionTotal': this.client.totalPayment,
      'transactionProducts': [
        {
          'quantity':  this.client.totalPayment,
          'price': this.client.totalPayment,
          'name': this.product.productType
        }
      ]
    });


    const quantity = this.product.vouchers[0].quantity;
    for (let i = 0; i < quantity; i++) {
      this.numberOfUsers.push(`Viajero ${i + 1}`);
    }

    const newArr = this.numberOfUsers.map(user => {
      const traveler = [];
      const listOns = this.addOnSelected.filter(ons => user === ons.customer);
      traveler.push({
        product: {
          ...this.product,
          totalPrice: this.product.totalPrice / this.numberOfUsers.length
        },
        addOns: listOns.map(ons => {
          return {
            ...ons,
            localPrice: ons.localPrice / this.numberOfUsers.length
          };
        }),
        customer: user
      });
      return traveler;
    });

    this.detailsUsersAndOnds = newArr.flat();

  }

  getGeneralOptions() {
    this._homeService.getGeneralOptions().subscribe(
      data => {
        this.generalData = data.data;
        this.arreglopromo = this.generalData.bennersregion.data;
      },
      err => {
        console.error(err);
      }
    );
  }

  backToPayment() {
    this.router.navigate(["/m/seguros/step-one"]);
  }

  getSessionname(newKey) {
    this.contactoService.getSessionName(this.newKey).subscribe((resp: any) => {
      this.sessionname = resp.sessionname;
    });
  }

  // get f() { return this.llamameForm.controls; }

  onSubmit(): void {
    this.submitted = true;
    this.loader = true;
    if (this.llamameForm.invalid) {
      return;
    } else {
      const params = {
        'sessionname': this.sessionname,
        'assigned_user_id': '19x32',
        'withnuxiba': true,
        'branch': '',
        'campaign': '',
        'firstname': this.llamameForm.value.nombre,
        'lastname': this.llamameForm.value.apellido,
        'phone': this.llamameForm.value.celular,
        // 'email': this.correo, //'rurba@yopmail.com',
        'email': 'rurba@yopmail.com',
        'state': '',
        'region': '',
        'destinationcountry': '',
        'destinationcity': '',
        'provider': 'Seguros',
        'travellive': 'Seguros',
        'webproduct': 'Seguros',
        'program': 'Seguros',
        'url': 'https://mundojoven.com/tours/norwegian-joy-de-norwegian-alaska/',
        //'url': //this.url, //'https://mundojoven.com/tours/norwegian-joy-de-norwegian-alaska/',
        'language': 'Inglés',
        'utmsource': '',
        'utmmedium': '',
        'utmcampaign': '',
        'subject': 'Click to Call',
        'tourtype': 'Seguros',
        'dateforcall': '04/03/2020 16:03',
        'dateofrequest': '04/03/2020 16:03',
        'departure_date': '',
        'arrival_date': '',
        'birthday': '',
        'description': 'Click to Call'
      };

      this.contactoService.envDataContacto(params).subscribe((res: any) => {
        //console.log(res);
        if (res.success === 'true') {
          this.loader = false;
          this.sendDataResponse = true;
          this.sendDataImage = 'https://mundojoven.com/wp-angular/src/assets/img/pagoSiendoProcesado.png';
          this.sendDataMessage = 'Tus datos han sido enviados';
          this.sendDataMessageTwo = 'A la brevedad nos pondremos en contacto contigo';
        } else {
          // alert('Hubo un error, intentalo mas tarde');
          this.loader = false;
          this.sendDataResponse = true;
          this.sendDataImage = 'https://mundojoven.com/wp-angular/src/assets/img/error.png';
          this.sendDataMessage = 'Ha ocurrido un error';
          this.sendDataMessageTwo = 'Inténtalo más tarde porfavor';
        }
      }); 

      
    }
  }

  get nombre(){
    return this.llamameForm.get('nombre');
  }

  get apellido(){
    return this.llamameForm.get('apellido');
  }

  get celular(){
    return this.llamameForm.get('celular');
  }

  goHome(){
    this.router.navigate(['/home']);
  }



}

function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
